module.exports = function() {
  return new Worker(__webpack_public_path__ + "448c05cce9c532a7807a.worker.js");
};